export interface DataEntity_Main_07_Interface {
    id: number,
    calibration_id: number,
    filename: string,

    pdf_src: string,

    manufacture: string,
    model: string,
    type: string,
    capability: string,

    unit_working: string,
    unit_reference: string,
    unit_indication: string,
    unit_error: string,
    unit_correction: string,
    unit_uncertainty: string,
    unit_eccentricity: string,
    unit_repeatability: string,


    mapping: string,
    before_from: string,
    before_to: string,
    before_method: string,

    ////Mohit
    temperature_Air_before: string,
    temperature_Air_after: string,

    humidity_Air_before: string,
    humidity_Air_after: string,

    pressure_before: string,
    pressure_after: string,

}

export function Empty_DataEntity_Main_07_Interface(): DataEntity_Main_07_Interface {
    return {
        id: 0,
        calibration_id: 0,
        filename: '',

        pdf_src: '',

        manufacture: '',
        model: '',
        type: '',
        capability: '',

        unit_working: '',
        unit_reference: '',
        unit_indication: '',
        unit_error: '',
        unit_correction: '',
        unit_uncertainty: '',
        unit_eccentricity: '',
        unit_repeatability: '',
    

        mapping: '',
        before_from: '',
        before_to: '',
        before_method: '',

        ////Mohit


        temperature_Air_before: '',
        temperature_Air_after: '',

        humidity_Air_before: '',
        humidity_Air_after: '',

        pressure_before: '',
        pressure_after: '',


    }
}

